import { styled } from '@linaria/react';

export const Section = styled.section`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;

export const IndicatorsTable = styled.table`
	width: 100%;
	padding: 0.8rem;
	border-radius: var(--radius-xs);
	background-color: var(--color-grey-6-solid);
	border-collapse: separate;
	border-spacing: 1.6rem 1rem;

	& th {
		&:where(:first-child, :last-child) {
			width: 1px;
			white-space: nowrap;
		}

		&:first-child {
			text-align: right;
		}

		&:last-child {
			text-align: left;
		}
	}
`;

export const IndicatorBar = styled.div<{ value: number }>`
	height: 0.3rem;
	border-radius: var(--radius-xxs);
	background-color: var(--color-white-m);

	&::before {
		display: block;
		width: ${(props) => props.value + '%'};
		height: 0.3rem;
		border-radius: var(--radius-xxs);
		background-color: var(--color-white-solid);
		content: '';
	}
`;
